import { Injectable } from '@angular/core';
import { BaseHttpWithBundleService } from '@app/core/services/base/base-service-with-bundle.service';
import { HttpServiceBundle } from '@app/core/services/base/http-service-bundle.service';
import { BackendUriUnits } from '@app/core/services/base/backend-uri-units';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { BaseList} from '@app/shared/models/list';
import { EmailProvider } from '@app/shared/models/email-provider';
import { DRResponse } from '@app/shared/models/response';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ProvidersService extends BaseHttpWithBundleService {

    constructor(httpServiceBundle: HttpServiceBundle) {
        super(httpServiceBundle, true);
        // Setting a new uri because this is not an SMP call
        this.uri += `/${BackendUriUnits.CLIENTS}/${BackendUriUnits.PROVIDERS}`;
    }

    // EXTRA METHODS ****************************************************************************************

    public getEmailProviders(): Observable<BaseList<EmailProvider>> {
        const uri = `${this.uri}/email`;
        return this.http.get<DRResponse<BaseList<EmailProvider>>>(uri)
                        .pipe(map(result  => new BaseList(EmailProvider, result.data)));
    }
}
